import Spin from "antd/lib/spin";
import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";
import React, { useState } from "react";
import { useLogin } from "./LoginHook";
import "./Login.scss";
import { useLocation } from "react-router";
import { toRouterPath } from "helpers/router-path";

const qs = require("qs");

interface LoginFields {
  username: string;
  password: string;
  deviceName: string;
}

function Login() {
  const location = useLocation();
  const [appUser, setAppUser] = useState<LoginFields>({
    username: "",
    password: "",
    deviceName: "",
  });
  const [errorMessageUsername, setErrorMessageUsername] = useState<string>(
    null
  );
  const [errorMessagePass, setErrorMessagePass] = useState<string>(null);
  const [, setErrorMessageOtp] = useState<string>(null);
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  const redirect = toRouterPath(
    qs.parse(location.search, { ignoreQueryPrefix: true }).redirect
  );

  const { loginVisible, loading, handleLogin, handleEnter } = useLogin(
    appUser,
    setErrorMessageUsername,
    setErrorMessagePass,
    setErrorMessageOtp,
    redirect || "/dashboard/default"
  );

  return (
    <>
      <div className="login-page">
        <div className="login-frame">
          <div className="login-brand">
            <img
              className="login-brand__logo"
              src={`${process.env.PUBLIC_URL}/logo-rallismart.png`}
              alt="RalliSmart"
            />
            <h1 className="login-brand__title">Đăng nhập</h1>
            <p className="login-brand__subtitle">Web quản trị hệ thống RalliSmart</p>
          </div>
          <Spin spinning={loading}>
            {loginVisible === true && (
              <div className="login-content">
                <div className="user-name">
                  <label htmlFor="login-username">
                    Tên đăng nhập <span className="text-danger">*</span>
                  </label>
                  <input
                    id="login-username"
                    type="text"
                    value={appUser.username}
                    className="ant-input input-login"
                    placeholder="Nhập tên đăng nhập"
                    onChange={(e) => {
                      setAppUser({
                        ...appUser,
                        username: e.target.value,
                      });
                    }}
                    onKeyDown={handleEnter}
                    autoComplete={"off"}
                  />
                  {errorMessageUsername !== null && (
                    <div className="login-error">{errorMessageUsername}</div>
                  )}
                </div>
                <div className="password">
                  <label htmlFor="login-password">
                    Mật khẩu <span className="text-danger">*</span>
                  </label>
                  <div className="login-password">
                    <input
                      id="login-password"
                      type={isPasswordVisible ? "text" : "password"}
                      value={appUser.password}
                      className="ant-input input-login"
                      placeholder="Nhập mật khẩu"
                      onChange={(e) => {
                        setAppUser({
                          ...appUser,
                          password: e.target.value,
                        });
                      }}
                      onKeyDown={handleEnter}
                    />
                    <button
                      type="button"
                      className="login-password__toggle"
                      onClick={() => setIsPasswordVisible((isVisible) => !isVisible)}
                      aria-label={isPasswordVisible ? "Ẩn mật khẩu" : "Hiện mật khẩu"}
                    >
                      {isPasswordVisible ? <EyeInvisibleOutlined /> : <EyeOutlined />}
                    </button>
                  </div>
                  {errorMessagePass !== null && (
                    <div className="login-error">{errorMessagePass}</div>
                  )}
                </div>
                <button
                  className="btn btn-primary btn-login"
                  onClick={handleLogin}
                  disabled={false}
                >
                  Đăng nhập
                </button>
              </div>
            )}
                  {/* {forgotPasswordVisible === true && (
                    <ForgotPassword
                      onChangeEmail={handleChangeEmail}
                      onSendMail={handleSendMail}
                      showLogin={showLogin}
                    />
                  )}

                  {getOtpVisible === true && (
                    <GetOtp
                      onChangeOtp={handleChangeOtp}
                      showLogin={showLogin}
                      onSendOtp={handleSendOtp}
                      otp={otp}
                      errorMessageOtp={errorMessageOtp}
                    />
                  )}
                  {changePassVisible === true && (
                    <ChangePassword
                      onChangeNewPass={handleChangeNewPass}
                      onChangeConfirmPassword={handleChangeConfirmPassword}
                      onChangePass={handleChangePass}
                      checkPass={checkPass}
                      confirmPass={confirmPass}
                      showLogin={showLogin}
                    />
                  )} */}
          </Spin>
        </div>
      </div>
    </>
  );
}

export default Login;
